import axios from 'axios';
import config from '../config/config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});


// API service functions
export const apiService = {
 // About page with team and values
  getAboutData: async () => {
    try {
      const response = await api.get('/get_about.php');
      
      return response.data;
    } catch (error) {
      console.error('Error fetching about data:', error);
      throw error;
    }
  },
  // AI Solutions page
  getAiSolutions: async () => {
    try {
      const response = await api.get('/ai_service.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching AI solutions:', error);
      throw error;
    }
  },
  // Add this inside apiService
getPage: async (slug) => {
  try {
    const response = await api.get(`/get_page.php?slug=${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching page:', error);
    throw error;
  }
},

  // Add this to your existing apiService object
getHomeData: async () => {
  try {
    const response = await api.get('/get_home.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching home data:', error);
    throw error;
  }
},
  // Services
  getServices: async () => {
    try {
      const response = await api.get('/get_services.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },
  // Public Config
 getPublicConfig: async () => {
    const response = await api.get('/public_config.php');
    return response.data;
 },

  // Hero (home page rotating backgrounds + interval)
  getHero: async () => {
    try {
      const response = await api.get('/get_hero.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching hero:', error);
      return { success: true, hero: { hero_images: [], rotation_interval_seconds: 5 } };
    }
  },

  // Header
  getHeader: async () => {
    try {
      const response = await api.get('/get_header.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching header:', error);
      throw error;
    }
  },

  // Footer
  getFooter: async () => {
    try {
      const response = await api.get('/get_footer.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching footer:', error);
      throw error;
    }
  },


  // Blogs
  getBlogs: async () => {
    try {
      const response = await api.get('/get_blogs.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching blogs:', error);
      return { success: false, posts: [] };
    }
  },
  getBlogBySlug: async (slug) => {
    try {
      const response = await api.get(`/get_blog_single.php?slug=${encodeURIComponent(slug)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog:', error);
      throw error;
    }
  },

  // Courses
  getCourses: async () => {
    try {
      const response = await api.get('/get_courses.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      return { success: false, courses: [] };
    }
  },
  getCourseBySlug: async (slug) => {
    try {
      const response = await api.get(`/get_course_single.php?slug=${encodeURIComponent(slug)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching course:', error);
      throw error;
    }
  },
  applyCourse: async (courseId, data) => {
    const response = await api.post('/apply_course.php', { course_id: courseId, ...data });
    return response.data;
  },
  checkEnrollment: async (courseId, email) => {
    const response = await api.get(`/check_enrollment.php?course_id=${courseId}&email=${encodeURIComponent(email)}`);
    return response.data;
  },
  getCourseContent: async (courseId, email) => {
    const response = await api.get(`/get_course_content.php?course_id=${courseId}&email=${encodeURIComponent(email)}`);
    return response.data;
  },

  // Careers
  getCareers: async () => {
    try {
      const response = await api.get('/get_careers.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching careers:', error);
      return { success: false, careers: [] };
    }
  },

  // Portfolio
  getPortfolio: async () => {
    try {
      const response = await api.get('/get_portfolio.php');
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      throw error;
    }
  },

  // Submit Quote
  submitQuote: async (quoteData) => {
    try {
      const response = await api.post('/submit_quote.php', quoteData);
      return response.data;
    } catch (error) {
      console.error('Error submitting quote:', error);
      throw error;
    }
  },

  // Submit Contact
  submitContact: async (contactData) => {
    try {
      const response = await api.post('/submit_contact.php', contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact:', error);
      throw error;
    }
  },

  // Chatbot
  chat: async (message, sessionId = null) => {
    const response = await api.post('/chat.php', { message, session_id: sessionId });
    return response.data;
  },

  // Analytics (fire-and-forget)
  trackEvent: (eventType, entityType = null, entityId = null, pagePath = null) => {
    let sessionId = null;
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionId = window.sessionStorage.getItem('_sid');
      if (!sessionId) {
        sessionId = 'sid_' + Math.random().toString(36).slice(2);
        window.sessionStorage.setItem('_sid', sessionId);
      }
    }
    api.post('/track_event.php', {
      event_type: eventType,
      entity_type: entityType || null,
      entity_id: entityId || null,
      page_path: pagePath || (typeof window !== 'undefined' ? window.location.pathname : null),
      session_id: sessionId
    }).catch(() => {});
  }
};

export default api;